export { StandardAvatars } from './StandardAvatars';
